export default __webpack_public_path__ + "static/media/powered-by.f221b880.png";